<div class="h-30"></div>
<div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always" [hidden]="updateUser.isParticipant">
    <mat-label>First Name</mat-label>
    <input matInput class="form-control-textbox" name="fname" [(ngModel)]="updateUser.firstName" [disabled]="coachOnly" />
  </mat-form-field>
</div>

<div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always" [hidden]="updateUser.isParticipant">
    <mat-label>Last Name</mat-label>
    <input matInput class="form-control-textbox" name="lname" [(ngModel)]="updateUser.lastName" [disabled]="coachOnly" />
  </mat-form-field>
</div>

<div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always" [hidden]="!updateUser.isParticipant">
    <mat-label>Display Name</mat-label>
    <input matInput class="form-control-textbox" name="dname" [(ngModel)]="updateUser.displayName" [disabled]="coachOnly" />
  </mat-form-field>
</div>

<div class="form-fields">
  <mat-form-field appearance="outline" floatLabel="always" >
    <mat-label>Email</mat-label>
    <input
      matInput
      class="form-control-textbox"
      [class.disabled-inputs]="!canEditEmail"
      name="username"
      [(ngModel)]="updateUser.email"
      [disabled]="!canEditEmail"
      required />
  </mat-form-field>
</div>

<div class="form-fields" [hidden]="!updateUser.isParticipant">
  <mat-form-field appearance="outline" floatLabel="always" >
    <mat-label>Program</mat-label>
    <input matInput class="form-control-textbox disabled-inputs" name="participantProgram" [(ngModel)]="updateUser.participantPrograms" disabled/>
  </mat-form-field>
</div>

<div class="form-fields">
  <mat-form-field >
    <mat-label>Select Roles</mat-label>
    <mat-select placeholder="Select" name="userRoles" multiple [(value)]="updateUser.applicationRoles" [disabled]="updateUser.isParticipant || coachOnly"
      [(ngModel)]="updateUser.applicationRoles">
      @for (roles of applicationRoles; track roles) {
        <mat-option [value]="roles.id">
          {{ roles.description }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div class="form-fields" [hidden]="!updateUser.isProvinceVisible">
  <mat-form-field>
    <mat-label>Province</mat-label>
    <mat-select placeholder="Select" name="province" [(value)]="updateUser.provinceId"
      [(ngModel)]="updateUser.provinceId" (selectionChange)="bindBranches()" (ngModelChange)="bindBranches()" [disabled]="updateUser.isProvinceDisabled || lockProvince">
      @for (province of provinces; track province) {
        <mat-option [value]="province.id">
          {{ province.provinceName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div class="form-fields" [hidden]="!updateUser.isBranchVisible || hideBranchForOntario">
  <mat-form-field>
    <mat-label>Branch</mat-label>
    <mat-select placeholder="Select" name="branch" [(value)]="updateUser.branchId"
      [(ngModel)]="updateUser.branchId" [disabled]="coachOnly">
      @for (item of filtereBranches; track item) {
        <mat-option [value]="item.id">
          {{ item.branchName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div class="form-fields" [hidden]="!updateUser.isCoachVisible">
  <mat-form-field>
    <mat-label>Coach</mat-label>
    <mat-select placeholder="Select" name="coach" [(value)]="updateUser.coachId"
      [(ngModel)]="updateUser.coachId">
      @for (item of coachedUsers; track item) {
        <mat-option [value]="item.userDbId">
          {{ item.name}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div class="form-fields" [hidden]="!updateUser.isOrgVisible" >
  <mat-form-field>
    <mat-label>Organization</mat-label>
    <mat-select placeholder="Select" name="org" [(value)]="updateUser.orgId"
      [(ngModel)]="updateUser.orgId" [disabled]="updateUser.isOrgDisabled">
      @for (item of filteredOrgs; track item) {
        <mat-option [value]="item.id">
          {{ item.organizationName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div class="form-fields" [hidden]="!updateUser.isFacilitatorVisible" >
  <mat-form-field>
    <mat-label>Facilitator</mat-label>
    <mat-select placeholder="Select" name="facilitator" [(value)]="updateUser.facilitatorId"
      [(ngModel)]="updateUser.facilitatorId" [disabled]="updateUser.isFacilitatorDisabled">
      @for (item of filteredFacilitators; track item) {
        <mat-option [value]="item.userDbId">
          {{ item.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div class="form-fields" [hidden]="!updateUser.isCohortVisible">
  <mat-form-field>
    <mat-label>Cohort</mat-label>
    <mat-select placeholder="Select" name="cohort" [(value)]="updateUser.cohort"
      [(ngModel)]="updateUser.cohort" [disabled]="updateUser.isCohortDisabled">
      @for (item of cohorts; track item) {
        <mat-option [value]="item.id">
          {{ item.cohortName }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div [style]="allowStatusChange?'':'pointer-events:none'">
  Status
  <div class="toggle">
    <div class="switch-div">
      <input type="radio" name="sizeBy" [value]="true" id="active" class="active"
        [(ngModel)]="updateUser.isActive" />
        <label for="active">Active</label>
      </div>
      <div class="switch-div">
        <input type="radio" name="sizeBy" [value]="false" id="inactive" class="inactive"
          [(ngModel)]="updateUser.isActive" />
          <label for="inactive">Inactive</label>
        </div>
      </div>
    </div>
    <div class="mb-10"></div>

